// istanbul ignore file: not testable

import {
  pluginTextColorViewer,
  pluginTextHighlightViewer,
  pluginLineSpacingViewer,
  pluginEmojiViewer,
  pluginSpoilerViewer,
  pluginCodeBlockViewer,
  pluginIndentViewer,
  pluginLinkViewer,
  pluginImageViewer,
  pluginVideoViewer,
  pluginDividerViewer,
  pluginFileUploadViewer,
  pluginVerticalEmbedViewer,
  pluginGiphyViewer,
  pluginMentionsViewer,
  pluginGalleryViewer,
  pluginCollapsibleListViewer,
  pluginTableViewer,
  pluginLinkButtonViewer,
} from '@wix/ricos';
import '@wix/ricos/css/plugin-spoiler-viewer.global.css';
import '@wix/ricos/css/plugin-divider-viewer.global.css';
import '@wix/ricos/css/plugin-link-viewer.global.css';
import '@wix/ricos/css/plugin-image-viewer.global.css';
import '@wix/ricos/css/plugin-video-viewer.global.css';
import '@wix/ricos/css/plugin-file-upload-viewer.global.css';
import '@wix/ricos/css/plugin-vertical-embed-viewer.global.css';
import '@wix/ricos/css/plugin-giphy-viewer.global.css';
import '@wix/ricos/css/plugin-mentions-viewer.global.css';
import '@wix/ricos/css/plugin-gallery-viewer.global.css';
import '@wix/ricos/css/plugin-collapsible-list-viewer.global.css';
import '@wix/ricos/css/plugin-table-viewer.global.css';
import '@wix/ricos/css/plugin-button-viewer.global.css';

export const usePlugins = () => {
  return [
    pluginTextColorViewer(),
    pluginTextHighlightViewer(),
    pluginLineSpacingViewer(),
    pluginIndentViewer(),
    pluginLinkViewer(),
    pluginImageViewer(),
    pluginVideoViewer(),
    pluginDividerViewer(),
    pluginFileUploadViewer(),
    pluginVerticalEmbedViewer(),
    pluginCodeBlockViewer(),
    pluginGalleryViewer(),
    pluginEmojiViewer(),
    pluginSpoilerViewer(),
    pluginGiphyViewer(),
    pluginMentionsViewer(),
    pluginCollapsibleListViewer(),
    pluginTableViewer(),
    pluginLinkButtonViewer(),
  ];
};
